
import React, { memo, useState } from "react";

import flex from "../../../styles/flex";
import styles from "./styles";

export type SelectableProps<T> = {
    items: T[];
    initialValue: T | null;
    onChange: (value: T) => void,
    onRenderItem: (item: T) => JSX.Element,
    style: React.CSSProperties;
    "data-testid"?: string;
};

function component<T>(props: React.PropsWithChildren<SelectableProps<T>>) {
    const [selectedItem, setSelectedItem] = useState<T | null>(props.initialValue);

    return <div style={{ ...styles.selectableContainer, ...props.style }} data-testid={props["data-testid"]}>
        {props.items.map((item, i) => {
            const selected = selectedItem == item;

            const isLastItem = props.items.length - 1 == i;
            const itemStyle = isLastItem == true ? { ...styles.selectableItem, ...styles.selectableItemLast } : styles.selectableItem;

            return <div key={i} style={selected == true ? { ...itemStyle, ...styles.selectableItemActive } : itemStyle} onClick={() => {
                setSelectedItem(item);
                props.onChange(item);
            }}>
                <div style={flex.flexRows}>
                    <div style={flex.flexAuto}>
                        <div style={selected == true ? styles.bulletActive : styles.bulletHidden}></div>
                    </div>
                    <div style={flex.flexFill}>
                        {props.onRenderItem(item)}
                    </div>
                </div>
            </div>
        })}
    </div>
}

export const Selectable = memo(component) as typeof component;
